import { useMutation } from '@tanstack/react-query';

import { getAuditIir } from '../../../../api';

export const useIIrAudit = () =>
  useMutation({ mutationKey: ['getAuditIir'], mutationFn: (data: Record<string, string | null>) => getAuditIir(data) });
